import React from 'react'

function HeadingDivider(props) {
  return <h2 className="heading-divider">{props.children}</h2>
}

export default HeadingDivider
